import { useTranslation } from 'react-i18next'
import stepsConfig from '../utils/firmwareInstructionSteps.json'

const findModelConfig = (config, modelName, defaultKey) => {
  if (!modelName || !config) return config?.[defaultKey] || config?._default || null

  const lowerModel = modelName.toLowerCase()

  for (const [key, value] of Object.entries(config)) {
    if (key.startsWith('_default')) continue

    const matchType = value.matchType || 'exact'

    if (matchType === 'exact' && key === modelName) {
      return value
    }

    if (matchType === 'includes' && lowerModel.includes(key.toLowerCase())) {
      return value
    }
  }

  return config?.[defaultKey] || config?._default || null
}

export const useFirmwareSteps = () => {
  const { i18n } = useTranslation()

  const getSegmentText = (segment) => {
    if (typeof segment.text === 'string') return segment.text
    return segment.text[i18n.language] || segment.text['en-CA'] || ''
  }

  const renderSegment = (segment, index, onVideoClick) => {
    const content = getSegmentText(segment)
    if (segment.type === 'videoLink') {
      return (
        <span key={index} className="instructions_firmware_video_link" onClick={onVideoClick}>
          {content}
        </span>
      )
    }
    if (segment.bold)
      return (
        <span key={index}>
          <strong>{content}</strong>
        </span>
      )
    if (segment.className)
      return (
        <span key={index} className={segment.className}>
          {content}
        </span>
      )
    return <span key={index}>{content}</span>
  }

  const renderStepsFromConfig = (modelConfig, firmwareVideoObj, onVideoClick) => {
    if (!modelConfig) return null
    let stepCounter = 1
    return (
      <>
        {modelConfig.steps.map((step, i) => {
          if (step.videoLinkStep && !firmwareVideoObj) return null
          let label
          if (step.stepLabel === 'indent') {
            label = <span className="title">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          } else {
            const stepNum = step.stepNumber != null ? step.stepNumber : stepCounter
            label = <span className="title">{`${stepNum}. `}</span>
          }
          if (step.stepLabel !== 'indent' && step.stepNumber == null) stepCounter++
          return (
            <div className="instruction" key={i}>
              {label}
              {step.segments.map((seg, segIdx) => renderSegment(seg, segIdx, step.videoLinkStep ? () => onVideoClick(firmwareVideoObj) : undefined))}
            </div>
          )
        })}
      </>
    )
  }

  const renderModelSteps = (modelName) => {
    const modelConfig = findModelConfig(stepsConfig, modelName, '_default')
    return renderStepsFromConfig(modelConfig)
  }

  const renderProductSteps = (modelName, firmwareVideoObj, onVideoClick) => {
    const modelConfig = findModelConfig(stepsConfig, modelName, '_default_products')
    return renderStepsFromConfig(modelConfig, firmwareVideoObj, onVideoClick)
  }

  return { renderModelSteps, renderProductSteps }
}
